import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import assets from "../assets/imgs";
import DOMPurify from "dompurify";
import config from "../config/config";
import {useUser} from "../context/UserContext";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const API_URL = config.API_URL;

function MonthlyReportWriteBox({onClose, boardId, title, startDate, endDate}){
  const {account, authority, company} = useUser();
  console.log('company is ', company);

  const [wrapList, setWrapList] = useState([]);
  const [contents, setContents] = useState("");
  const [editing, setEditing] = useState(false);
  const [wrapId, setWrapId] = useState(null);

  const reportName = '월간 보고 자료';

  // const planPage = true;
  // const now = new Date();
  // const kstNow = new Date(now.getTime() + (9 * 60 * 60 * 1000)); // UTC+9 적용
  // const today = kstNow.toISOString().split("T")[0];
  
  const popupAnchorRef = useRef(null);
  
  const [formData, setFormData] = useState({}); // 변경시 입력 및 저장시 이용 데이터

  // console.log('onclose state', onClose);

  const handleUpdate = async ()=>{
    console.log('update 요청');
    await uploadMR();
    // onClose();
  }
  // const handleCategory = (key) => {
  //   setSelectedCategory(key);
  // };
  const handleChange = (value) =>{
    setContents(value);
  }

  const handleEdit = () =>{
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 오늘 날짜의 00:00:00
    const utc = today.getTime() + (today.getTimezoneOffset() * 60000);
    const koreaTime = new Date(utc + (9 * 60 * 60000));
    koreaTime.setHours(0, 0, 0, 0);

    const targetDate = new Date(endDate);
    targetDate.setHours(0, 0, 0, 0);
    // console.log(today, koreaTime, targetDate);

    const isFutureOrToday = targetDate < today;
    if(isFutureOrToday){
      alert('작성 기한이 지나 작성이 불가합니다.');
      return;
    }
    setEditing(true);
  }

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose(false);
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const uploadMR = async () =>{
    try {
      let jsonBody 
      console.log(wrapId);
      if(wrapId){
        jsonBody = JSON.stringify({board_id : boardId, contents: contents, wrap_id: wrapId});
      }else{
        jsonBody = JSON.stringify({board_id : boardId, contents: contents});
      }      

      const response = await fetch(`${API_URL}/api/board/putMonthlyWrap`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: jsonBody,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.result) {
        alert(`월간 보고 자료가 성공적으로 저장되었습니다.`);
        await fetchData();
        setEditing(false);
      } else {
        alert(`${result.message}`);
      }
    } catch (error) {
      alert("업로드에 오류가 발생하였습니다.", error);
      // setError(error.message); // 에러 메시지 저장
    }
  }

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/getMonthlyWrap`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          _id : boardId,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          startup_name: row.startup_name || "-",
          user_name : row.user_name || "-" ,
          contents : row.contents || '',
          log_date : row.log_date ? row.log_date.split("T")[0] : "-",
        }));
        setWrapList(formattedData);
        setContents(result.value[0]?.contents || "");
        setWrapId(result.value[0]?._id || null);
      } else {
        alert("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.log('조회 오류: ', error);
      alert("조회에 오류가 발생하였습니다.");
      // setError(error.message); // 에러 메시지 저장
    } 
  };

  // console.log('get 내용', wrapList);

  useEffect(() =>  {
    if(boardId){
      fetchData();
    }
  }, [boardId]);

  useEffect(() => {
    // setHtmlValue('');
    setWrapList([]);
    setContents("");
    setWrapId(null);
    setEditing(false);
  }, [onClose]);

  const handleDownload = () => {
    // const excelData = [];

    // // 첫 줄: 헤더
    // const header = ["업체명", `${String(dummyDate.getFullYear()).slice(2)}/${String(dummyDate.getMonth() + 1).padStart(2, "0")} 출근현황`];
    // for (let i = 1; i <= 30; i++) {
    //   header.push(`${i}일`);
    // }
    // excelData.push(header);

    // // 데이터 변환
    // commuteData.forEach((item) => {
    //   const row = [];
    //   row.push(item.name);

    //   const count = item.commute.filter((c) => c.check === 1).length;
    //   row.push(`${count}/30`);

    //   item.commute.forEach((entry) => {
    //     row.push(entry.check === 1 ? "O" : "X");
    //   });

    //   excelData.push(row);
    // });
    const data = wrapList.map(row => ({
      기업명: row.startup_name,
      작성자: row.user_name,
      내용: stripHtmlWithNewlines(row.contents),
      작성일: row.log_date,
    }));

    // 워크시트 생성
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 워크북 생성
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${title}`);

    // 엑셀 파일로 저장
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, `${title}.xlsx`);
  };

  const stripHtmlWithNewlines = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html.replace(/<br\s*\/?>/gi, '\n'); // <br> → \n
    return div.textContent || div.innerText || '';
  }

  const quillModules ={
    toolbar: [
      [{ font: [] }], // 글꼴 선택
      [{ size: [] }], // 글자 크기
      [{ color: [] }, { background: [] }], // 글자색 및 배경색
      ["bold", "italic", "underline", "strike"], // 굵기, 기울기, 밑줄, 취소선
      [{ script: "sub" }, { script: "super" }], // 위첨자, 아래첨자
      [{ list: "ordered" }, { list: "bullet" }], // 순서 있는 목록, 순서 없는 목록
      [{ indent: "-1" }, { indent: "+1" }], // 들여쓰기 감소, 증가
      [{ align: [] }], // 정렬
      ["link", "image"], // 링크, 이미지 업로드
      ["blockquote", "code-block"], // 인용구, 코드 블록
      [{ direction: "rtl" }], // 오른쪽에서 왼쪽 정렬
      ["clean"], // 포맷 초기화
    ],
  }
  // console.log('boardaccount:', boardContents.account);
  // console.log('user', account, authority);

  return (
    <div style={styles.overlay}>
      <div style={{...styles.modal,
        ...({width : "80%", height:"90%"})
      }}>
        <div style={styles.header}>
          <h3 className='font-s-head4-semibold'>{editing ? `${reportName} 작성` : `${reportName}`}</h3>
          <div style={styles.topRightHeader}>
            <div style={styles.xBox} onClick={() => onClose(false)}>
              <assets.icons.icon_x/>
            </div>
          </div>
        </div>
        <div style={styles.body}>
          {/* 타이틀 입력 */}
          <div style={styles.setSection}>
            <h3 className='font-body4-semibold'>{"제목"}</h3>
            <p className='font-body3-semibold' style={styles.textInput}>{title}</p>            
          </div>
          <div style={styles.setSection}>
            <h3 className='font-body4-semibold'>일정</h3>
            <div style={{display: "flex", gap: "12px", justifyContent: "space-between",}}>
              <div style={{...styles.dateInput, cursor: "default"}}>
                <img src={assets.icons.calendar} style={styles.calendarIcon}/>
                <p>{startDate ?? "-"}</p>
              </div>
              <div style={{...styles.dateInput, cursor: "default"}}>
                <img src={assets.icons.calendar} style={styles.calendarIcon}/>
                <p>{endDate ?? "-"}</p>
              </div>              
            </div>
          </div>
          {editing ? (
            <ReactQuill
              theme="snow"
              value={contents || ""}
              onChange={(content) => handleChange(content)}
              style={styles.quillStyle}
              modules={quillModules}
            />
          ): (
            <div style={{...styles.setSection, flex:1, overflow: "auto"}}>
              <table border="1" cellPadding="8" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                  <tr>
                    <th style={{width: "150px"}}>기업명</th>
                    <th style={{width: "80px"}}>작성자</th>
                    <th>내용</th>
                    <th style={{width: "90px"}}>작성일</th>
                  </tr>
                </thead>
                <tbody>
                  {wrapList.map((row, idx) => (
                    <tr key={idx}>
                      <td style={styles.tableCell}>{row.startup_name}</td>
                      <td style={styles.tableCell}>{row.user_name}</td>
                      <td style={styles.tableCell}>
                        <div style={styles.quillOutputStyle} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(row.contents) }}
                          className='ql-editor'></div>
                      </td>
                      <td style={styles.tableCell}>{row.log_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* 다운로드 버튼 */}
          {(!editing && authority >=5) && (
            <div style={styles.btnLine}>
              <div style={styles.btnUpload} onClick={handleDownload} className='font-body2-semibold'> {"엑셀 다운로드"}</div>
            </div>
          )}

          {/* 등록 버튼 */}
          {editing && (
            <div style={styles.btnLine}>
              <div style={styles.btnUpload} onClick={handleUpdate} className='font-body2-semibold'> {"등록 하기"}</div>
            </div>
          )}
          {/* 수정 버튼 */}
          {(!editing && (authority <=4 && authority >=3)) && (
            <div style={styles.btnLine}>
              <div style={styles.btnUpload} onClick={handleEdit} className='font-body2-semibold'> {"작성 하기"}</div>
            </div>
          )}
        </div>
        
      </div>
    </div>
  );
}

const topRightHeaderIcon = {
  cursor:"pointer",
  width: "20px",
  height:"20px"
};

const styles ={
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // 반투명 배경
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "20px",
    width: "80%",
    height: "80%",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    display: "flex",
    flexDirection: "column"
  },
  header:{
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--grayscale_20)",
    justifyContent: "space-between",
    padding: "14px 20px",
    borderTopRightRadius : "20px",
    borderTopLeftRadius : "20px"
  },
  topRightHeader: {
    display: "flex",
    gap: "40px",
    alignItems: "center",
  },
  xBox:{
    ...topRightHeaderIcon,
    display:"flex",
    alignItems:"center",
    justifyContent: "center",    
  }, 
  body:{
    display: "flex",
    flexDirection : "column",
    padding: "35px 35px 40px 35px",
    flex: 1,
    overflow: "auto"
  },
  setSection:{
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "20px",
  },
  textInput:{
    height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px" ,
    display: "flex", alignItems: "center", minHeight: "45px",
  },
  dateInput: {
    display:"flex", gap: "10px", height: "45px", borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)", padding: "0px 12px", 
    alignItems: "center", position:"relative", flex: 1
  },
  btnLine: {
    display: "flex",
    justifyContent: "space-between",
  },
  calendarIcon: {
    width:"20px",
    height: "20px"
  },
  quillStyle:{
    // borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    // padding: "12px",
    marginBottom: "80px",
    flex: 1
  },
  quillOutputStyle:{
    // borderRadius: "8px", border: "1px solid var(--grayscale-cool_50)",
    padding: "8px",
    flex: 1
  },
  monthCheckBox:{
    display: "flex", gap: "6px", alignItems: "center", cursor: "pointer"
  },
  btnUpload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    backgroundColor : "var(--primary-crimson_40)",
    borderRadius: "8px",
    cursor: "pointer",
    height: "48px", width:"150px"
  },
  tableCell: {
    textAlign: "center",
  }
}


export default MonthlyReportWriteBox;